module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAh0lEQVQ4y2NgGBTg/5Ej/6Oq9/4/cuH5///h4WDaMW3zf5A4g/FM3BgGQJpBipENAPFBhiBr+H7gMHYD/gPB379//4MB0ABkQJQLwJpgWE7uPzIfm8b3O/ejGgDzL4oXVqz439u/F1UDThdMn/7fr3AHigHVXfuJD0S8igaVATijcRB4YUgDAPCdUp5U475BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NZ.png
// module id = 1234
// module chunks = 0